import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from "react";

import Home from './components/Home';
import OurProcess from './components/OurProcess';
import Facilities from './components/Facilities';
import ContactUs from './components/ContactUs';
import OurWork from './components/OurWork';
import OurStory from './components/OurStory';
import AboutUs from './components/AboutUs';

import "@fancyapps/ui/dist/fancybox/fancybox.css";
import CookieBanner from './CookieBanner';

function App() {

useEffect(() => {

  const supportedLangs = ["en","es","fr","it","ar","hi","de","pt"];

  const browserLang =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    "en";

  const lang = browserLang.toLowerCase().split("-")[0];

  const finalLang = supportedLangs.includes(lang) ? lang : "en";

  // if browser is english, remove translation
  if (finalLang === "en") {
    document.cookie = "googtrans=/en/en;path=/";
    return;
  }

  const cookieValue = `/en/${finalLang}`;

  document.cookie = `googtrans=${cookieValue};path=/`;
  document.cookie = `googtrans=${cookieValue};path=/;domain=${window.location.hostname}`;

}, []);

  return (
    <Router>
      <div className="App">

        {/* hidden translate container */}
        <div id="google_translate_element" style={{display:"none"}}></div>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/our-process" element={<OurProcess />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>

        <CookieBanner />

      </div>
    </Router>
  );
}

export default App;